<header
    #top
    class="header"
>
    <div class="header__content">
        <img
            [src]="infomaniakLogoPath"
            [alt]="'Logo Infomaniak' | transloco"
            class="heaader__logo"
        >

        <nav class="header__nav">
            <ul class="header__menu list list--flex">
                <li class="header__menu-item header__menu-item--nohover header__language">
                    <mat-form-field class="lang">
                        <mat-select
                            class="langSelect"
                            [(ngModel)]="config.language"
                        >
                            <mat-option
                                mat-option
                                class="header__language-option"
                                *ngFor="let language of languages"
                                (click)="setLanguage(language)"
                                [value]="language"
                            >
                                {{ language }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </li>
            </ul>
        </nav>
    </div>
</header>
